import React from "react";
import styled from "styled-components";

const IcStar = ({className, isActive, onClick}) => {
    return (
        <StarContainer className={className}>
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="asset/Star">
                    <path
                        id="Star"
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.99963 14.8701L5.15234 17.4184L6.07809 12.0209L2.15655 8.19833L7.57599 7.41084L9.99963 2.5L12.4233 7.41084L17.8427 8.19833L13.9212 12.0209L14.8469 17.4184L9.99963 14.8701Z"
                        fill={isActive ? "#FFD333" : "#fff"}
                        stroke={isActive ? "#FFD333" : "#B0B0B0"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </svg>
        </StarContainer>
    );
};

const StarContainer = styled.div`
  display: inline-block;
  cursor: pointer;
  font-size: 0;
`;

export default IcStar;
